module.exports = __webpack_public_path__ + "c734088a9a6b270eb84b2e223519678d.png";